import React, { useState, useRef, useLayoutEffect, useEffect } from "react";

function AccordionItem({
  title,
  children,
  className,
}) {
  const contentRef = useRef(null);
  const wrapperRef = useRef(null);
  const [height, setHeight] = useState(0);
  const [isActive, setIsActive] = useState(false);

  // UseEffect: updates the height of the accordion when content changes
  useLayoutEffect(() => {
    if (isActive && contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    }
  }, [isActive, children]);

  // Use ResizeObserver to handle dynamic resizing (e.g., images loading)
  useEffect(() => {
    if (!isActive || !contentRef.current) return;

    const observer = new ResizeObserver(() => {
      if (contentRef.current) {
        setHeight(contentRef.current.scrollHeight);
      }
    });

    observer.observe(contentRef.current);

    return () => observer.disconnect();
  }, [isActive, children]);

  const handleToggle = () => {
    setIsActive(!isActive);
  };

  return (
    <div className={`border border-gray-300 mb-4 rounded-lg shadow-sm ${className || ""}`}>
      <button
        onClick={handleToggle}
        className={`accordion-button ${isActive ? "" : "collapsed"} w-full text-left p-4`}
        type="button"
      >
        <div className="flex-grow">
          {typeof title === "function"
            ? title(isActive)
            : React.isValidElement(title)
            ? React.cloneElement(title, {
                className: `${title.props.className || ""} ${isActive ? "open" : ""}`,
              })
            : title}
        </div>
        {/* Freccia temporaneamente rimossa per debug */}
      </button>
      <div
        className="transition-all duration-300 ease-in-out overflow-hidden"
        style={{
          height: isActive ? `${height}px` : "0px", // Dynamically set the height
        }}
        ref={wrapperRef}
      >
        <div ref={contentRef} className="p-4 bg-gray-50">
          {children}
        </div>
      </div>
    </div>
  );
}

export { AccordionItem };
